import React, { useState, useEffect, useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box, Paper } from '@mui/material';
import api from '../api/api';
import Loading from '../components/loading';

function NotificationModal() {

  const [notifications, setNotifications] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const getNotifications = useCallback(() => {
    api.get(`/notifications/${sessionStorage.getItem('userEmail')}`, {
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then((returnFromApi) => {
      const data = returnFromApi.data;
      if (data.length > 0) {
        setNotifications(data);
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    }).catch((returnFromApi) => {
      console.error("ops! ocorreu um erro" + returnFromApi);
    });
  }, []);

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  function markAsRead() {
    setLoading(true);
    api.post(`/notifications/${sessionStorage.getItem('userEmail')}/read`, null, {
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(() => {
      setLoading(false);
      setShowModal(false);
    }).catch((returnFromApi) => {
      setLoading(false);
      console.error("ops! ocorreu um erro" + returnFromApi);
    });
  }

  return (
    <>
      <Dialog
        open={showModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            border: '1px solid #ccc'
          }
        }}
      >
        <Loading isToHidden={isLoading === false} />
        
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold' }}>
          Notificações
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: 'grey.100' }}>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {notifications.map((notification) => (
              <Paper
                key={notification.id}
                variant="outlined"
                sx={{ p: 2, bgcolor: 'background.paper' }}
              >
                <Typography component="div" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                  {notification.title}
                </Typography>
                <Typography variant="body1">
                  {notification.content}
                </Typography>
              </Paper>
            ))}
          </Box>


        </DialogContent>

        <DialogActions sx={{ p: '16px 24px' }}>
          <Button variant="contained"
            onClick={() => markAsRead()}>
            Marcar como lido
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NotificationModal;